'use client';

import { PageHeader, TextLink, TextPassage } from '@petsmart-ui/sparky';
import { SUPPORT_PHONE_NUMBER } from '@libs/shared-ui';
import './SearchPageError.scss';

export default function SearchPageError({
    searchTerm,
}: Readonly<{
    searchTerm: string | null | undefined;
}>) {
    const description = (
        <>
            <TextPassage>We couldn’t find a match for your search.</TextPassage>
            <TextPassage className="search-error__contact">
                Can’t find what you’re looking for? Contact customer care at{' '}
                <TextLink href={`tel:${SUPPORT_PHONE_NUMBER.RAW}`}>
                    {SUPPORT_PHONE_NUMBER.FORMATTED}
                </TextLink>
                .
            </TextPassage>
        </>
    );

    return (
        <PageHeader
            className="search-error"
            align="center"
            title={`“${searchTerm}”`}
            description={description}
        />
    );
}
